import React from "react"
import Breadcrumb from "../../../shared/components/atoms/breadcrumb/breadcrumb"
import { useStaticQuery, graphql } from "gatsby"
import HeaderContact from "../../molecules/header-contact/header-contact"

import "./contact-content.scss"
import Faq from "../../molecules/faq/faq"
import FormQuestion from "../../molecules/form-question/form-question"
import ContactUs from "../../molecules/contact-us/contact-us"

const ContactContent = props => {
  const { mobile } = props

  const resultQuery = useStaticQuery(
    graphql`
      query CONTACT_QUERY {
        allContentfulNolContactanos {
          nodes {
            node_locale
            banner {
              file {
                details {
                  image {
                    height
                  }
                }
                url
              }
              fixed {
                base64
              }
              description
            }
            preguntasFrecuentes {
              nombreEtiqueta
              referenciasDeLaEtiqueta {
                ... on ContentfulNolDesplegableLegal {
                  tituloPrincipal
                  descripcion {
                    json
                  }
                }
              }
            }
          }
        }
      }
    `
  )

  const filteredResultQuery = resultQuery.allContentfulNolContactanos.nodes.filter(
    e => e.node_locale === process.env.LOCALE
  )[0]

  return (
    <div className="f-contact-content">
      <div className="f-breadcrum-position">
        <Breadcrumb mobile={props.mobile} />
      </div>
      <HeaderContact banner={filteredResultQuery.banner} mobile={mobile} />
      <Faq mobile={mobile} faq={filteredResultQuery.preguntasFrecuentes} />
      <FormQuestion
        mobile={mobile}
        faq={filteredResultQuery.preguntasFrecuentes}
        title="Contáctanos"
      />
      <ContactUs />
    </div>
  )
}

export default ContactContent
